<template>
  <div class="transition-global totemBG tw-h-screen tw-w-screen">
    <div v-if="eventPrintError" class="event-print-warning" role="alert">
      {{ eventPrintError }}
      <button
        type="button"
        :disabled="eventPrinting"
        @click="EnviarParaServiceImpressora"
      >
        Verificar impressão
      </button>
    </div>
    <div v-if="isCapitureLead" class="contentDefault">
      <div class="tw-text-center tw-self-start">
        <vBtnReset v-if="sucessoImpressora || showRestartButton" />
        <vLogoDefault />
      </div>
      <div class="centerContent">
        <BoxAgradecimento
          v-if="sucessoImpressora"
          compact
          @finish="finishFinalScreen"
        />
        <template v-else>
          <div class="imp-carousel tw-pb-16">
            <transition name="fade-carousel" mode="out-in">
              <span :key="fraseAtual" class="imp-carousel-text tw-text-4xl">
                {{ frasesCarrossel[fraseAtual] }}
              </span>
            </transition>
          </div>
          <div class="tw-pb-5 tw-pt-20">
            <vImpressoraAnimation />
          </div>
          <div
            class="tw-transform tw--rotate-6 tw-my-10 tw-relative tw-text-center tw-mx-auto tw-text-white"
            style="width: 450px"
          >
            <div
              class="tw-flex tw-flex-row tw-justify-items-center"
              style="max-width: 400px"
            >
              <div class="tw-flex-1">
                <div class="tw-font-medium tw-text-4xl tw-uppercase">
                  Descontos
                </div>
              </div>
              <div>
                <svg
                  viewBox="0 0 150 20"
                  xmlns="http://www.w3.org/2000/svg"
                  class="tw-text-pink-500 tw-stroke-current tw-mt-1 tw--ml-8"
                  style="width: 150px"
                  stroke-width="8"
                >
                  <line
                    x1="10"
                    y1="20"
                    x2="150"
                    y2="20"
                    stroke="currentColor"
                  />
                </svg>
              </div>
            </div>
            <div
              class="tw-flex tw-flex-row tw-justify-items-center tw-relative"
            >
              <div class="">
                <svg
                  viewBox="0 0 180 20"
                  xmlns="http://www.w3.org/2000/svg"
                  class="tw-text-pink-500 tw-stroke-current tw-pr-2 tw--ml-10 tw-mt-1"
                  stroke-width="8"
                  style="width: 180px"
                >
                  <line
                    x1="0"
                    y1="20"
                    x2="180"
                    y2="20"
                    stroke-linecap="round"
                    stroke="currentColor"
                  />
                </svg>
              </div>
              <div>
                <span class="tw-font-medium tw-text-4xl tw-pl-2 tw-uppercase"
                  >E PROMOÇÕES</span
                >
              </div>
            </div>
          </div>
        </template>

        <div class="imp-form-area">
          <div v-if="!leadSalvo">
            <label class="imp-input-label">Informe o seu celular</label>

            <div class="imp-input-wrapper">
              <input
                ref="phoneInput"
                type="tel"
                v-model="telefone"
                @keypress.enter="salvarTelefone"
                @click="ativaTeclado()"
                placeholder="(xx) xxxxx-xxxx"
                class="imp-phone-input"
                maxlength="15"
                :disabled="leadLoading"
              />
            </div>

            <NumericKeyboard
              ref="refNumericKeyboardComponent"
              :value="telefone"
              :limitCharacters="15"
              :mostrar="mostrarKeyboard"
              :aplicarAoEnter="fecharKeyboard"
              @focusInput="$refs.phoneInput && $refs.phoneInput.focus()"
              @input="telefone = $event"
              @fechar="fecharKeyboard"
            />

            <div v-if="erroLead" class="imp-error">{{ erroLead }}</div>

            <button
              class="imp-cta-btn"
              @click="salvarTelefone"
              :disabled="leadLoading || !telefoneValido"
            >
              <span v-if="!leadLoading">Cadastrar e receber ofertas</span>
              <span v-else>Salvando...</span>
            </button>
          </div>

          <div v-if="leadSalvo" class="imp-success">
            &#10003; Número cadastrado com sucesso!
          </div>
          <div class="tw-flex tw-flex-row tw-justify-center tw-items-center">
            <div class="tw-text-right tw-mt-6 tw-p-5 tw-rounded-lg tw-bg-white">
              <canvas ref="qrcodeCanvas" class="tw-mx-auto" />
            </div>
            <div class="tw-text-left tw-pl-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                class="tw-w-28 tw-h-28 tw-mx-auto tw-mt-3"
                aria-label="Instagram"
              >
                <defs>
                  <radialGradient id="ig-grad" cx="30%" cy="107%" r="150%">
                    <stop offset="0%" stop-color="#fdf497" />
                    <stop offset="5%" stop-color="#fdf497" />
                    <stop offset="45%" stop-color="#fd5949" />
                    <stop offset="60%" stop-color="#d6249f" />
                    <stop offset="90%" stop-color="#285AEB" />
                  </radialGradient>
                </defs>
                <rect
                  width="24"
                  height="24"
                  rx="5.5"
                  ry="5.5"
                  fill="url(#ig-grad)"
                />
                <rect
                  x="2.5"
                  y="2.5"
                  width="19"
                  height="19"
                  rx="4"
                  ry="4"
                  fill="none"
                  stroke="white"
                  stroke-width="1.5"
                />
                <circle
                  cx="12"
                  cy="12"
                  r="4.5"
                  fill="none"
                  stroke="white"
                  stroke-width="1.5"
                />
                <circle cx="17.5" cy="6.5" r="1" fill="white" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div class="imp-footer"></div>
    </div>

    <div
      v-if="!isCapitureLead"
      class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-h-screen"
    >
      <div class="tw-text-center tw-flex-none">
        <vBtnReset v-if="sucessoImpressora || showRestartButton" />
        <vLogoDefault />
      </div>
      <div class="tw-flex tw-justify-center tw-flex-1">
        <BoxAgradecimento
          v-if="sucessoImpressora"
          @finish="finishFinalScreen"
        />
      </div>
      <ImpressaoSemLead v-if="!sucessoImpressora" />
    </div>

    <vModalErroImpressao
      v-if="modalErroImpressao && !modalReembolso"
      :contagem="contagemErrosImpressao"
      @close="tentarNovamente"
    />
    <vModalReembolso
      v-if="modalReembolso"
      @finalizar="finalizarFluxoReembolso()"
    />
  </div>
</template>

<script>
import { registrarAceiteUsoMolduras } from "@/service/molduraUsageTelemetry";
import { ehEvento } from "@/constants/types/tipoTotem";
import { quotaReservation, prepareQuotaDispatch, acceptPhotoQuota, markQuotaUncertain, isPrintServiceAcceptance } from "@/service/eventPhotoQuota";
import {
  db,
  registrarImpressaoConfirmada,
  registrarRibbon,
  setEtapaCompra,
} from "@/service/firebase";
import posthog from "@/posthog";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
} from "@firebase/firestore";
import anime from "animejs";
import { tiposDeFotos } from "@/constants/tipoFoto";
import {
  getFormatoImpressao,
  getCalibracaoImpressao,
} from "@/constants/printer";
import { getDownloadURL, listAll, ref } from "@firebase/storage";
import { storageInst } from "../../../service/firebase";
import vModalErroImpressao from "./ModalErroImpressao.vue";
import vModalReembolso from "./ModalReembolso.vue";
import NumericKeyboard from "@/components/NumericKeyboard.vue";
import { CapiturarLeads } from "@/service/capituraLeads";
import { RestartTotem } from "@/utils/utilsTotem";
import ServicePrinter from "@/service/printer";
import QRCode from "qrcode";
import vImpressoraAnimation from "./vImpressoraAnimation.vue";
import etapa from "@/constants/etapaCompra";
import BoxAgradecimento from "@/components/BoxAgradecimento.vue";
import ImpressaoSemLead from "./vImpressaoSemLead.vue";
import { comTimeout } from "@/utils/promiseTimeout";
import timePage from "@/constants/timeout_page";
import {
  currentAttendance,
  freezeEventPlan,
  eventAttendanceStatus,
  isPhysicallyCompleted,
  isMonitorCompleted,
  saveAttendance,
  assertEventSession,
} from "@/service/eventAttendance";

const TIMEOUT_FIRESTORE_MS = 20000;

export default {
  components: {
    ImpressaoSemLead,
    vModalErroImpressao,
    vModalReembolso,
    NumericKeyboard,
    vImpressoraAnimation,
    BoxAgradecimento,
  },
  data() {
    return {
      modalReembolso: false,
      modalErroImpressao: false,
      contagemErrosImpressao: 0,
      frasesCarrossel: [
        "Segure a emoção, já estamos imprimindo! 😍",
        "Preparando sua foto com carinho! 💖",
        "Um instante… sua memória inesquecível vem aí! ⏳",
        "Aguardamos ansiosos para ver seu sorriso impresso! 😃",
        "Sua foto está chegando… Segure a emoção 😬",
      ],
      fraseAtual: 0,
      intervalCarrossel: null,
      listaReferencias: [],
      listaImagens: [],
      // Captura de lead
      telefone: "",
      leadLoading: false,
      erroLead: "",
      mostrarKeyboard: false,
      leadSalvo: false,
      sucessoImpressora: false,
      showRestartButton: false,
      timerShowRestartButton: null,
      timerFinalScreen: null,
      timerRetryPrint: null,
      timerPrintCompletion: null,
      finalScreenFinished: false,
      eventPrinting: false,
      eventUsageAttempted: false,
      eventPrintError: "",
      eventPollTimer: null,
      eventDestroyed: false,
    };
  },
  computed: {
    isCapitureLead() {
      return this.$store.getters["totem/getTotem"]?.config?.modo_capitura_lead;
    },
    telefoneValido() {
      if (!this.telefone) return false;
      const n = this.telefone.replace(/\D/g, "");
      return n.length >= 10 && n.length <= 11;
    },
    compraId() {
      return this.$store.getters["compra/getID"];
    },
  },
  watch: {
    telefone(newVal) {
      this.formatarTelefone(newVal);
    },
    sucessoImpressora(newVal) {
      this.finalScreenFinished = false;
      if (newVal) this.startFinalScreenTimer();
      else this.clearFinalScreenTimer();
    },
  },
  beforeMount() {
    this.BuscarUrlDoFirebaseStorage();
  },
  mounted() {
    this.animaMounted();
    document.addEventListener("click", this.handleClickOutside);
    this.$nextTick(() => {
      if (this.$refs.phoneInput) this.$refs.phoneInput.focus();
    });
    this.intervalCarrossel = setInterval(() => {
      this.fraseAtual = (this.fraseAtual + 1) % this.frasesCarrossel.length;
    }, 5000);
    this.gerarQrCodeInstagram();
    const compra = this.$store.getters["compra/getCompra"];
    if (compra?.telefone) {
      this.telefone = this.formatarNumero(compra.telefone);
    }
    this.createTimerForRestartButton();
  },
  beforeDestroy() {
    this.eventDestroyed = true;
    clearTimeout(this.eventPollTimer);
    clearInterval(this.intervalCarrossel);
    clearTimeout(this.timerShowRestartButton);
    this.clearFinalScreenTimer();
    clearTimeout(this.timerRetryPrint);
    clearTimeout(this.timerPrintCompletion);
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    createTimerForRestartButton() {
      this.timerShowRestartButton = setTimeout(() => {
        const id = this.$store.getters["totem/getTotem"]?.id;
        this.showRestartButton = !currentAttendance(id);
      }, 15000);
    },
    startFinalScreenTimer() {
      this.clearFinalScreenTimer();
      this.timerFinalScreen = setTimeout(() => {
        this.finishFinalScreen();
      }, timePage.AGRADECIMENTO * 1000);
    },
    clearFinalScreenTimer() {
      clearTimeout(this.timerFinalScreen);
      this.timerFinalScreen = null;
    },
    finishFinalScreen() {
      if (this.finalScreenFinished) return;
      this.finalScreenFinished = true;
      this.clearFinalScreenTimer();
      RestartTotem();
    },
    handleClickOutside(event) {
      const keyboard = this.$refs.refNumericKeyboardComponent;
      const input = this.$refs.phoneInput;

      if (
        keyboard &&
        !keyboard.$el.contains(event.target) &&
        !(input && input.contains(event.target))
      ) {
        this.mostrarKeyboard = false;
      }
    },
    async gerarQrCodeInstagram() {
      const totem = this.$store.getters["totem/getTotem"];
      const instagramUrl = totem?.instagram
        ? totem.instagram
        : "https://www.instagram.com/photonow_oficial";
      if (!instagramUrl || !this.$refs.qrcodeCanvas) return;
      try {
        await QRCode.toCanvas(this.$refs.qrcodeCanvas, instagramUrl, {
          width: 176,
          margin: 1,
          color: { dark: "#000000", light: "#ffffff" },
        });
      } catch (err) {
        console.error("Erro ao gerar QR code:", err);
      }
    },
    ativaTeclado() {
      this.mostrarKeyboard = true;
    },
    fecharKeyboard() {
      this.mostrarKeyboard = false;
    },
    formatarTelefone(newVal) {
      this.erroLead = "";
      let value = newVal.replace(/\D/g, "");
      if (value.length <= 11) {
        if (value.length <= 2) {
          this.telefone = value;
        } else if (value.length <= 6) {
          this.telefone = `(${value.slice(0, 2)}) ${value.slice(2)}`;
        } else if (value.length <= 10) {
          this.telefone = `(${value.slice(0, 2)}) ${value.slice(
            2,
            6
          )}-${value.slice(6)}`;
        } else {
          this.telefone = `(${value.slice(0, 2)}) ${value.slice(
            2,
            7
          )}-${value.slice(7, 11)}`;
        }
      }
    },
    formatarNumero(numero) {
      const value = numero.replace(/\D/g, "");
      if (value.length <= 10) {
        return `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6)}`;
      } else {
        return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7)}`;
      }
    },
    validarTelefone() {
      const n = this.telefone.replace(/\D/g, "");
      if (n.length < 10) {
        this.erroLead = "Telefone incompleto";
        return false;
      }
      const ddd = parseInt(n.slice(0, 2));
      if (ddd < 11 || ddd > 99) {
        this.erroLead = "DDD inválido";
        return false;
      }
      return true;
    },
    async salvarTelefone() {
      if (!this.telefoneValido || !this.validarTelefone()) return;
      this.leadLoading = true;
      this.erroLead = "";
      try {
        const numeroLimpo = this.telefone.replace(/\D/g, "");
        await CapiturarLeads(numeroLimpo);
        const compraRef = doc(db, "compras", this.compraId);
        await updateDoc(compraRef, {
          telefone: numeroLimpo,
          telefoneFormatado: this.telefone,
          aceitouPromocoes: true,
        });
        this.$store.commit("compra/setCompra", {
          ...this.$store.getters["compra/getCompra"],
          telefone: numeroLimpo,
          telefoneFormatado: this.telefone,
          aceitouPromocoes: true,
        });
        this.leadSalvo = true;
        this.fecharKeyboard();
      } catch (error) {
        console.error("Erro ao salvar lead:", error);
        this.erroLead = "Erro ao salvar. Tente novamente.";
        this.$root.sendOneError(error, "Erro ao salvar lead na impressão");
      } finally {
        this.leadLoading = false;
      }
    },
    // Totem comum: só passa pela cota se houver reserva desta compra. Sem a
    // sessão do Firebase Auth a consulta lança erro — e a impressão travava
    // sem aviso. Sem sessão não há reserva legível: segue sem cota.
    temReservaDeCota(totemId, compraId) {
      if (!totemId) return false;
      try {
        return !!quotaReservation(totemId, compraId);
      } catch (erro) {
        console.warn("Não foi possível consultar a reserva da cota", erro);
        return false;
      }
    },
    ControladorDeErros() {
      this.contagemErrosImpressao++;
      if (this.contagemErrosImpressao > 5) {
        this.modalErroImpressao = false;
        this.modalReembolso = true;
      } else {
        this.modalErroImpressao = true;
        this.modalReembolso = false;
      }
    },
    finalizarFluxoReembolso() {
      this.modalErroImpressao = false;
      this.contagemErrosImpressao = 0;
      RestartTotem();
    },
    tentarNovamente() {
      this.closeModal();
      clearTimeout(this.timerRetryPrint);
      this.timerRetryPrint = setTimeout(() => {
        this.timerRetryPrint = null;
        // Se a falha foi ao baixar as fotos, não adianta reenviar uma lista
        // vazia para a impressora: refaz o passo do download.
        if (!this.listaImagens.length) {
          this.BuscarUrlDoFirebaseStorage();
        } else {
          this.EnviarParaServiceImpressora();
        }
      }, 1000);
    },
    closeModal() {
      this.modalErroImpressao = false;
    },
    async EnviarParaServiceImpressora() {
      const compra = this.$store.getters["compra/getCompra"];
      let tipoFoto = compra.tipo_foto;
      const compraId = this.compraId;
      const totemId = this.$store.getters["totem/getTotem"]?.id;

      const listaImagens = this.listaImagens;
      const tipoFotoUpper = tipoFoto.toUpperCase();
      // O serviço da impressora ainda recebe feature_flag para aplicar o
      // layout Polaroid v2, que é o padrão de todos os totens.
      const isFeaturePolaroid = tipoFoto === tiposDeFotos.POLAROID;

      const configTotem = this.$store.getters["totem/getTotem"]?.config;
      const formato = getFormatoImpressao(configTotem?.impressora);
      // Calibração específica para a combinação impressora + tipo de foto.
      const offset = getCalibracaoImpressao(
        configTotem,
        configTotem?.impressora,
        tipoFoto
      );

      const session = currentAttendance(totemId);
      if (session) {
        await this.imprimirEvento(session, {
          fotosUrl: listaImagens,
          tipo: tipoFotoUpper,
          feature_flag: isFeaturePolaroid,
          formato,
          x: offset.x,
          y: offset.y,
          jobId: compraId,
          purchaseId: compraId,
          totemId,
        });
        return;
      }

      const quotaRequired = ehEvento(this.$store.getters["totem/getTotem"]?.tipoTotem)
        || this.temReservaDeCota(totemId, compraId);
      const assertQuotaScope = () => {
        if (this.$store.getters["totem/getTotem"]?.id !== totemId || this.compraId !== compraId
          || this.$store.getters["compra/getCompra"]?.id && this.$store.getters["compra/getCompra"].id !== compraId) {
          throw new Error("A sessão mudou durante o envio reservado. Solicite conferência.");
        }
      };
      if (quotaRequired) {
        try { assertQuotaScope(); await prepareQuotaDispatch(totemId, compraId, listaImagens.length); assertQuotaScope(); }
        catch (error) {
          this.eventPrintError = "O envio está reservado para conferência. Peça ajuda ao organizador; não imprima novamente.";
          this.ControladorDeErros();
          return;
        }
      }

      ServicePrinter.devicePrint(
        listaImagens,
        tipoFotoUpper,
        isFeaturePolaroid,
        formato,
        offset,
        compraId && totemId
          ? { jobId: compraId, purchaseId: compraId, totemId }
          : null
      )
        .then(async (response) => {
          if (quotaRequired) {
            assertQuotaScope();
            if (!isPrintServiceAcceptance(response, { purchaseId: compraId })) throw new Error("O serviço não confirmou o aceite da impressão.");
            await acceptPhotoQuota(totemId, compraId);
            assertQuotaScope();
          }
          registrarAceiteUsoMolduras(compraId, totemId, listaImagens.length).catch((error) => {
            console.error("Falha ao registrar uso das molduras aceitas pelo serviço", error);
          });
          // Aceite do serviço, não confirmação de saída física do papel.
          // Não bloqueia a tela quando a telemetria falha; retry é idempotente.
          if (listaImagens.length > 0) {
            registrarImpressaoConfirmada(compraId, listaImagens.length).catch(
              (error) => {
                console.error(
                  "Falha ao registrar impressão confirmada:",
                  error
                );
                this.$root.sendOneError(error, "Telemetria de impressão");
              }
            );
          }
          posthog.capture("print_completed", {
            photo_count: listaImagens.length,
            photo_type: tipoFoto,
          });
          this.setContadores();
          this.validaTerminoDaImpressao();
        })
        .catch(async (err) => {
          if (quotaRequired) await markQuotaUncertain(totemId, compraId).catch(() => {});
          this.ControladorDeErros();
          console.error(err);
          this.$root.sendOneError(
            "Erro na impressora ao enviar a lista",
            "/v1/printer"
          );
        });
    },
    assertEventPrintScope(session, payload) {
      assertEventSession(payload.totemId, session);
      if (
        this.$store.getters["totem/getTotem"]?.id !== payload.totemId ||
        this.compraId !== payload.purchaseId ||
        session.purchaseId !== payload.purchaseId ||
        !payload.purchaseId
      )
        throw new Error("Atendimento não corresponde à compra atual.");
      if (
        session.plan &&
        (session.plan.jobId !== payload.jobId ||
          session.plan.purchaseId !== payload.purchaseId)
      )
        throw new Error("Plano não corresponde à compra atual.");
    },
    async imprimirEvento(session, payload) {
      if (this.eventPrinting || this.eventDestroyed || this.sucessoImpressora)
        return;
      clearTimeout(this.eventPollTimer);
      this.eventPrinting = true;
      this.eventPrintError = "";
      this.showRestartButton = false;
      const id = payload.totemId;
      try {
        this.assertEventPrintScope(session, payload);
        const attendance = {
          attendanceId: session.attendanceId,
          eventId: session.eventId,
          reservationToken: session.reservationToken,
          jobId: payload.jobId,
          purchaseId: payload.purchaseId,
          totemId: id,
        };
        if (!session.plan) {
          const response = await ServicePrinter.eventPreflight({
            ...payload,
            attendance,
          });
          const manifest = response.data;
          if (this.eventDestroyed) return;
          this.assertEventPrintScope(session, payload);
          if (
            !/^[a-f0-9]{64}$/.test(manifest.manifestHash) ||
            !Number.isSafeInteger(manifest.expectedUnits) ||
            manifest.expectedUnits < 1 ||
            manifest.expectedUnits > 1000 ||
            !["NORMAL", "POLAROID", "3X4"].includes(manifest.format)
          )
            throw new Error("Pré-validação de impressão inválida.");
          session = await freezeEventPlan(id, session, {
            jobId: payload.jobId,
            purchaseId: payload.purchaseId,
            manifestHash: manifest.manifestHash,
            format: manifest.format,
            expectedUnits: manifest.expectedUnits,
          });
        }
        if (this.eventDestroyed) return;
        this.assertEventPrintScope(session, payload);
        // Same frozen job on every retry. Native journal/prepare refuses second dispatch.
        const quota = quotaReservation(id, payload.purchaseId);
        // An uncertain legacy send is never repeated. The attendance service's
        // private journal can be polled, preserving its independent code flow.
        if (!quota || quota.status === "RESERVED") {
          await prepareQuotaDispatch(id, payload.purchaseId, payload.fotosUrl.length);
          await ServicePrinter.eventPrint({
            ...payload,
            attendance: { ...attendance, ...session.plan },
          });
        }
        if (!this.eventDestroyed)
          await this.consultarImpressaoEvento(session, payload);
      } catch (_) {
        await markQuotaUncertain(id, payload.purchaseId).catch(() => {});
        if (!this.eventDestroyed)
          this.eventPrintError =
            "Não foi possível confirmar a impressão. O código continua reservado. Verifique novamente ou peça ajuda ao organizador.";
      } finally {
        this.eventPrinting = false;
      }
    },
    async consultarImpressaoEvento(session, payload) {
      if (this.eventDestroyed) return;
      this.assertEventPrintScope(session, payload);
      const response = await ServicePrinter.eventStatus(payload.jobId, session);
      if (this.eventDestroyed) return;
      this.assertEventPrintScope(session, payload);
      const local = response.data;
      if (local.jobId !== payload.jobId) throw new Error("Trabalho incorreto.");
      if (!this.eventUsageAttempted && local.dispatchAccepted === true &&
        local.attendanceId === session.attendanceId && local.eventId === session.eventId &&
        local.manifestHash === session.plan?.manifestHash &&
        Array.isArray(payload.fotosUrl) && payload.fotosUrl.length > 0 &&
        local.acceptedCompositionCount === payload.fotosUrl.length) {
        await acceptPhotoQuota(payload.totemId, payload.purchaseId);
        this.eventUsageAttempted = true;
        registrarAceiteUsoMolduras(payload.purchaseId, payload.totemId, payload.fotosUrl.length).catch(() => {
          if (!this.eventDestroyed) this.eventUsageAttempted = false;
          console.error("Falha ao registrar uso das molduras aceitas no Evento");
        });
      }
      const monitorCompleted = isMonitorCompleted(local, session);
      if (monitorCompleted || local.status === "COMPLETED" &&
        local.physicallyConfirmed && local.receiptAcknowledged) {
        if (!monitorCompleted) {
          const cloud = await eventAttendanceStatus(payload.totemId, session);
          if (this.eventDestroyed) return;
          this.assertEventPrintScope(session, payload);
          if (!isPhysicallyCompleted(local, cloud)) throw new Error("Recibo ainda pendente.");
        }
        // The private native journal durably holds the complete monitor receipt.
        // Backend delivery may follow after connectivity returns; no new code is
        // admitted offline and this completed plan must never be submitted again.
        if (!session.counted) {
          await this.setContadores();
          if (this.eventDestroyed) return;
          this.assertEventPrintScope(session, payload);
          saveAttendance(payload.totemId, { ...session, counted: true });
        }
        this.sucessoImpressora = true;
        setEtapaCompra(etapa.AGRADECIMENTO);
        return;
      }
      if (["UNCERTAIN", "PARTIAL", "FAILED"].includes(local.status))
        throw new Error("Impressão precisa de conferência.");
      this.eventPollTimer = setTimeout(() => {
        this.consultarImpressaoEvento(session, payload).catch(() => {
          if (!this.eventDestroyed)
            this.eventPrintError =
              "A confirmação está pendente. O código continua reservado; peça ajuda ao organizador.";
        });
      }, 2000);
    },
    validaTerminoDaImpressao() {
      clearTimeout(this.timerPrintCompletion);
      this.timerPrintCompletion = setTimeout(() => {
        this.timerPrintCompletion = null;
        this.sucessoImpressora = true;
        setEtapaCompra(etapa.AGRADECIMENTO);
      }, 10000);
    },
    getScopeFirebase(name) {
      //OBS: A ORDEM É IMPORTANTE [0],[1]
      //Operação [-],[+]
      console.log("GetScope", name);
      if (name == tiposDeFotos.POLAROID) {
        return [
          "countPolaroid",
          "countPolaroidTotal",
          "countPolaroidRibbon",
          "countPolaroidRibbonTotal",
        ];
      } else if (
        name == tiposDeFotos.NORMAL ||
        name == tiposDeFotos.FOTOS_3X4 ||
        name == tiposDeFotos.PASSAPORTE
      ) {
        return [
          "countNormal",
          "countNormalTotal",
          "countNormalRibbon",
          "countNormalRibbonTotal",
        ];
      } else {
        console.error("Contagem não pode ser efetuada");
        return false;
      }
    },
    async aplicaCalculo(scope, resultado, totemID) {
      // ! revisar resultado
      console.log("AplicaCalculo", scope, resultado);
      const nameSpaceFirebase = this.getScopeFirebase(scope);
      const referencia = doc(db, "totem", totemID);
      const nameCount = nameSpaceFirebase[0];
      const nameTotal = nameSpaceFirebase[1];
      const nameRibbonCount = nameSpaceFirebase[2];
      const nameRibbonCountTotal = nameSpaceFirebase[3];
      await setDoc(
        referencia,
        {
          contadores: {
            [nameCount]: resultado.count,
            [nameTotal]: resultado.total,
            [nameRibbonCount]: resultado.ribbonCount,
            [nameRibbonCountTotal]: resultado.ribbonTotal,
            //[nameRibbonCount]: resultado.
          },
        },
        { merge: true }
      )
        .then(() => {
          console.log("SUCESSO NO ENVIO DOS CALCULOS");
        })
        .catch((err) => {
          console.log("Erro ao tentar gravar calculo Normal: ", err);
        });
    },
    getFolhasImpressas() {
      const dadosCompra = this.$store.getters["compra/getCompra"];
      if (dadosCompra.foto_tipo === tiposDeFotos.POLAROID) {
        return Math.ceil(dadosCompra.qtde_foto / 2);
      } else {
        //todos os tipos menos POLAROID
        return dadosCompra.qtde_foto;
      }
    },
    pipelineRibonSetter(ribonResult) {
      console.log(ribonResult);
    },
    calculaRibon() {
      const count = this.getFolhasImpressas();
      registrarRibbon(count);
    },
    calculaValores() {
      console.log("INIT CalculaValores");
      const dadosCompra = this.$store.getters["compra/getCompra"];
      const dadosTotem = this.$store.getters["totem/getTotem"];
      const tipoFoto = dadosCompra.tipo_foto;
      console.log(tipoFoto);
      console.log(
        tiposDeFotos.POLAROID,
        tiposDeFotos.NORMAL,
        tiposDeFotos.FOTOS_3X4
      );
      if (tipoFoto == tiposDeFotos.POLAROID) {
        const quantidade = Number(dadosCompra.qtde_foto / 2);
        const totemCountTotal = dadosTotem.contadores.countPolaroidTotal;
        const totemCount = dadosTotem.contadores.countPolaroid;
        const totemCountRibbonTotal =
          dadosTotem.contadores.countPolaroidRibbonTotal;
        const totemCountRibbon = dadosTotem.contadores.countPolaroidRibbon;
        let resultadoPolaroid = {};
        resultadoPolaroid.count = totemCount - quantidade;
        resultadoPolaroid.total = totemCountTotal + quantidade;
        resultadoPolaroid.ribbonCount = totemCountRibbon
          ? totemCountRibbon - quantidade
          : 0;
        resultadoPolaroid.ribbonTotal = totemCountRibbonTotal
          ? totemCountRibbonTotal + quantidade
          : quantidade;
        this.aplicaCalculo("polaroid", resultadoPolaroid, dadosTotem.id);
      } else if (
        tipoFoto == tiposDeFotos.NORMAL ||
        tipoFoto === tiposDeFotos.FOTOS_3X4 ||
        tipoFoto === tiposDeFotos.PASSAPORTE
      ) {
        const quantidade = Number(dadosCompra.qtde_foto);
        const totemCountTotal = dadosTotem.contadores.countNormalTotal;
        const totemCount = dadosTotem.contadores.countNormal;
        const totemCountRibbonTotal =
          dadosTotem.contadores.countNormalRibbonTotal;
        const totemCountRibbon = dadosTotem.contadores.countNormalRibbon;
        let resultadoNormal = {};
        resultadoNormal.count = totemCount - quantidade;
        resultadoNormal.total = totemCountTotal + quantidade;
        resultadoNormal.ribbonCount = totemCountRibbon
          ? totemCountRibbon - quantidade
          : 0;
        resultadoNormal.ribbonTotal = totemCountRibbonTotal
          ? totemCountRibbonTotal + quantidade
          : quantidade;
        this.aplicaCalculo("normal", resultadoNormal, dadosTotem.id);
      } else {
        console.error("ERROR|calculaValores: NENHUM DOS CASOS DE TIPO DE FOTO");
      }
      //this.calculaRibon();
    },
    async setContadores() {
      this.calculaValores();
    },
    async BuscarUrlDoFirebaseStorage() {
      const compra = this.$store.getters["compra/getCompra"];
      const pastaEditada = ref(storageInst, `public/${compra.id}/editada`);
      try {
        const resultado = await listAll(pastaEditada);
        const urls = await Promise.all(
          resultado.items.map((item) => getDownloadURL(item))
        );
        this.listaImagens = urls;
        // Com await, uma falha no envio cai no catch abaixo em vez de virar
        // erro solto com o cliente parado na tela de impressão.
        await this.EnviarParaServiceImpressora();
      } catch (err) {
        console.error("Erro ao listar arquivos editados do bucket:", err);
        this.$root.sendOneError(
          `Falha ao preparar a impressão: ${err && err.message}`,
          "BuscarUrlDoFirebaseStorage"
        );
        this.ControladorDeErros();
      }
    },
    async getReferencesImages() {
      let self = this;
      let compra = this.$store.getters["compra/getCompra"];
      let fotosRef = collection(db, "fotos");
      let searchQuery = query(
        fotosRef,
        where("compra_id", "==", `${compra.id}`)
      );

      // Sem try/catch, um getDocs que rejeita (offline, App Check) deixava a
      // tela de impressão parada sem nunca chegar no BuscarUrlDoFirebaseStorage.
      try {
        let querySnaps = await comTimeout(getDocs(searchQuery), {
          ms: TIMEOUT_FIRESTORE_MS,
          rotulo: "getDocs fotos",
        });
        querySnaps.forEach((doc) => {
          let bin = doc.data();
          let forgeObj = {
            id: doc.id,
            url_editada: bin.url_editada,
            url_original: bin.url_original,
            compra_id: bin.compra_id,
          };
          self.listaReferencias.push(forgeObj);
        });
      } catch (err) {
        console.error(err);
        this.$root.sendOneError(
          `Falha ao buscar as fotos da compra: ${err.message}`,
          "getReferencesImages"
        );
        this.ControladorDeErros();
        return;
      }

      this.$nextTick(() => {
        this.BuscarUrlDoFirebaseStorage();
      });
    },
    animaMounted() {
      anime({
        targets: ".transition-global",
        opacity: {
          value: 1,
          delay: 0,
          duration: 800,
          easing: "easeInOutExpo",
        },
      });
    },
  },
};
</script>

<style scoped>
.backdrop {
  background-color: rgba(255, 255, 255, 0.2);
  -webkit-backdrop-filter: blur(15px);
  backdrop-filter: blur(15px);
}
.totemBG {
  background-size: cover;
  background-image: linear-gradient(
      180deg,
      #978fc4 0%,
      #a78ebd 34.84%,
      rgba(207, 138, 172, 0.8) 100%
    ),
    url("../../../assets/fundo.png");
}
.centerContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
}

.transition-global {
  opacity: 0;
}

/* ── Tela principal ─────────────────────────────────────────────── */
.contentDefault {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr auto 1fr;
  align-items: center;
  text-align: center;
}

/* ── Logo ───────────────────────────────────────────────────────── */
.imp-logo-area {
  width: 100%;
  padding: 16px 24px 0;
}

/* ── Formulário ─────────────────────────────────────────────────── */
.imp-form-area {
  width: 100%;
  max-width: 540px;
  padding: 28px 32px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.imp-input-label {
  font-size: 1.15rem;
  font-weight: 800;
  color: #fff;
  margin-bottom: 10px;
  letter-spacing: 0.04em;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.45);
  display: block;
}

.imp-input-wrapper {
  margin-bottom: 20px;
}

.imp-phone-input {
  width: 100%;
  padding: 18px 22px;
  font-size: clamp(1.4rem, 4vw, 1.9rem);
  font-weight: 600;
  border: 2.5px solid #e8197d;
  border-radius: 12px;
  outline: none;
  text-align: center;
  color: #111;
  background: #fff;
  transition: box-shadow 0.25s ease, border-color 0.25s ease;
  letter-spacing: 2px;
}

.imp-phone-input::placeholder {
  color: #bbb;
  font-weight: 400;
  letter-spacing: 1px;
}

.imp-phone-input:focus {
  box-shadow: 0 0 0 4px rgba(232, 25, 125, 0.18);
}

.imp-phone-input:disabled {
  opacity: 0.6;
}

.imp-cta-btn {
  width: 100%;
  padding: 18px 24px;
  font-size: clamp(1rem, 3vw, 1.3rem);
  font-weight: 800;
  background: #e8197d;
  color: #fff;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.25s ease, transform 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 14px;
}

.imp-cta-btn:hover:not(:disabled) {
  background: #c5136a;
  transform: translateY(-2px);
}

.imp-cta-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* ── Feedback ───────────────────────────────────────────────────── */
.imp-error {
  color: #d32f2f;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  margin-bottom: 12px;
  background: rgba(211, 47, 47, 0.08);
  border-radius: 8px;
  padding: 10px 16px;
}

.imp-success {
  color: #2e7d32;
  font-size: 1.1rem;
  font-weight: 700;
  text-align: center;
  background: white;
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 8px;
}

/* ── Footer skip ────────────────────────────────────────────────── */
.imp-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 32px 36px;
  align-self: end;
}

.imp-skip-btn {
  padding: 14px 32px;
  background: transparent;
  border: 2px solid #ccc;
  border-radius: 10px;
  color: #666;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.imp-skip-btn:hover:not(:disabled) {
  border-color: #e8197d;
  color: #e8197d;
}

.imp-skip-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Responsividade ─────────────────────────────────────────────── */
@media (min-width: 900px) {
  .imp-title {
    font-size: 5rem;
  }
  .imp-phone-input {
    font-size: 2.2rem;
    padding: 22px 28px;
  }
  .imp-cta-btn {
    font-size: 1.5rem;
    padding: 22px 28px;
  }
}

@media (min-height: 1200px) {
  .imp-hero {
    padding-top: 48px;
  }
  .imp-form-area {
    padding-top: 48px;
  }
}

/* ── Carrossel de frases ────────────────────────────────────────── */
.imp-carousel {
  width: 80%;
  text-align: center;
  min-height: 100px;
  max-height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.imp-carousel-text {
  display: block;
  font-weight: 700;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  letter-spacing: 0.02em;
  padding: 0 12px;
}

.fade-carousel-enter-active,
.fade-carousel-leave-active {
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.fade-carousel-enter {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-carousel-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* ── Animações ──────────────────────────────────────────────────── */
@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.25;
  }
}
</style>
